import { atom } from "recoil";

const KEY = "message-ids";

export interface MessageType {
    messageId: number;
    type: string;
    createdAt?: string;
}

export const MessageIdsAtom = atom<MessageType[]>({
    key: KEY,
    default: [],
});
